import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ProductInterface } from '@core/products';
import { RetailMediaCampaignType } from '@rmn/models/enums/retail-media-campaign-type.enum';
import { InteractionsModule } from '@shared/interactions';
import { UiModule } from '@shared/ui/ui.module';
import { RetailMediaCampaignWithFullProductInterface } from '../../models/retail-media-campaign.interface';
import { RetailMediaProductsSearchComponent } from '../products/retail-media-products-search/retail-media-products-search.component';
import { RetailMediaProductsSelectedComponent } from '../products/retail-media-products-selected/retail-media-products-selected.component';

@Component({
    selector: 'rm-campaign-products-form',
    templateUrl: './retail-media-campaign-products-form.component.html',
    styleUrls: ['./retail-media-campaign-products-form.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        UiModule,
        InteractionsModule,
        RetailMediaProductsSearchComponent,
        RetailMediaProductsSelectedComponent
    ]
})
export class RetailMediaCampaignProductsFormComponent {
    @Input()
    public form!: FormControl<ProductInterface[]>;

    @Input()
    public recentCampaigns: RetailMediaCampaignWithFullProductInterface[] = [];

    @Input()
    public campaignType?: RetailMediaCampaignType | null;

    @Input()
    public lastCampaignsLoading = false;

    @Output()
    public onSubmit = new EventEmitter();

    @ViewChild('search')
    public search!: RetailMediaProductsSearchComponent;

    protected CampaignType = RetailMediaCampaignType;

    protected onSelect(product: ProductInterface): void {
        this.form.setValue([...this.form.getRawValue(), product]);
        this.form.markAsDirty();
    }

    protected onRemove(id: ProductInterface['id']): void {
        this.form.setValue(this.form.getRawValue().filter(item => item.id !== id));
        this.form.markAsDirty();
    }

    protected onClear(): void {
        this.form.setValue([]);
        this.form.markAsDirty();
    }

    protected onSelectCampaign(campaign: RetailMediaCampaignWithFullProductInterface): void {
        for (const product of campaign.products) {
            this.onSelect(product);
        }
    }

    public clearSearch(): void {
        this.search.clearInput();
    }
}
